(function () {
  var storageKey = 'alma_cart_production_deadline_session_v1';
  var duration = 15 * 60 * 1000;
  var intervalId = null;
  var syncTimer = null;

  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-alma-cart-timer]'));
  }

  function readDeadline() {
    try {
      return parseInt(window.sessionStorage.getItem(storageKey), 10) || 0;
    } catch (error) {
      return window.__almaCartUrgencyDeadline || 0;
    }
  }

  function writeDeadline(value) {
    window.__almaCartUrgencyDeadline = value;
    try {
      if (value) {
        window.sessionStorage.setItem(storageKey, String(value));
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {}
  }

  function stopInterval() {
    if (!intervalId) return;
    window.clearInterval(intervalId);
    intervalId = null;
  }

  function render() {
    var deadline = readDeadline();
    var remaining = deadline - Date.now();
    var active = deadline > 0 && remaining > 0;
    var state = deadline <= 0 ? 'empty' : active ? 'active' : 'expired';

    blocks().forEach(function (block) {
      var countdown = block.querySelector('[data-alma-cart-countdown]');
      block.setAttribute('data-alma-cart-timer-state', state);
      block.hidden = !active;

      if (active && countdown) {
        var seconds = Math.max(0, Math.ceil(remaining / 1000));
        var minutes = Math.floor(seconds / 60);
        var remainder = seconds % 60;
        countdown.textContent = String(minutes).padStart(2, '0') + ':' + String(remainder).padStart(2, '0');
      }
    });

    if (!active) stopInterval();
    return active;
  }

  function ensureInterval() {
    if (intervalId || document.hidden || !render()) return;
    intervalId = window.setInterval(render, 1000);
  }

  function setCartState(hasGoods) {
    if (!hasGoods) {
      writeDeadline(0);
      stopInterval();
      render();
      return;
    }

    var deadline = readDeadline();
    if (!deadline) {
      deadline = Date.now() + duration;
      writeDeadline(deadline);
    }

    render();
    if (deadline > Date.now()) ensureInterval();
  }

  function hasItemsInCartMarkup() {
    return Array.prototype.some.call(document.querySelectorAll('[data-products]'), function (region) {
      return Boolean(region.querySelector('.cart__item, [data-cart-item], [data-line-item]'));
    });
  }

  function syncFromMarkup() {
    setCartState(hasItemsInCartMarkup());
  }

  function scheduleMarkupSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncFromMarkup, 120);
  }

  function init() {
    if (window.__almaCartUrgencyReady) {
      scheduleMarkupSync();
      return;
    }

    window.__almaCartUrgencyReady = true;
    document.documentElement.setAttribute('data-alma-cart-timer-ready', 'true');

    document.addEventListener('ajaxProduct:added', function () {
      setCartState(true);
    });
    document.addEventListener('cart:updated', scheduleMarkupSync);
    document.addEventListener('cart:build', scheduleMarkupSync);
    document.addEventListener('cart:change', scheduleMarkupSync);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopInterval();
      } else {
        syncFromMarkup();
      }
    });

    document.querySelectorAll('[data-products]').forEach(function (target) {
      new MutationObserver(scheduleMarkupSync).observe(target, { childList: true, subtree: true });
    });

    var initialHasGoods = blocks().some(function (block) {
      return Number(block.getAttribute('data-alma-cart-initial-count') || 0) > 0;
    });

    setCartState(initialHasGoods || hasItemsInCartMarkup());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
